/**
 * Runway Gen-3 Alpha reference clips (official Runway research showcase).
 * Used on landing + dashboard as examples of scene video from Runway-powered pipelines.
 * @see https://runwayml.com/research/introducing-gen-3-alpha
 */
export const RUNWAY_SHOWCASE_REFERENCE_URL =
  'https://runwayml.com/research/introducing-gen-3-alpha';

export const dashboardShowcaseMovies = [
  {
    id: 'runway-train-reflection',
    title: 'Midnight Express',
    style: 'Cinematic · Narrative',
    provider: 'Runway Gen-3 Alpha',
    prompt:
      'Subtle reflections of a woman on the window of a train moving at hyper-speed in a Japanese city.',
    videoUrl:
      'https://d3phaj0sisr2ct.cloudfront.net/site/videos/gen-3-alpha/carousel-01/gen-3-alpha-output-001.mp4',
  },
  {
    id: 'runway-astronaut-rio',
    title: 'Rio Runner',
    style: 'Action · Urban',
    provider: 'Runway Gen-3 Alpha',
    prompt: 'An astronaut running through an alley in Rio de Janeiro.',
    videoUrl:
      'https://d3phaj0sisr2ct.cloudfront.net/site/videos/gen-3-alpha/carousel-01/gen-3-alpha-output-002.mp4',
  },
  {
    id: 'runway-underwater-fpv',
    title: 'Coral Suburb',
    style: 'Fantasy · FPV',
    provider: 'Runway Gen-3 Alpha',
    prompt:
      'FPV flying through colorful coral-lined streets of an underwater suburban neighborhood.',
    videoUrl:
      'https://d3phaj0sisr2ct.cloudfront.net/site/videos/gen-3-alpha/carousel-01/gen-3-alpha-output-003.mp4',
  },
  {
    id: 'runway-tv-portrait',
    title: 'Glow Portrait',
    style: 'Drama · Close-up',
    provider: 'Runway Gen-3 Alpha',
    prompt: 'A cinematic wide portrait of a man with his face lit by the glow of a TV.',
    videoUrl:
      'https://d3phaj0sisr2ct.cloudfront.net/site/videos/gen-3-alpha/humans/gen-3-alpha-output-001.mp4',
  },
  {
    id: 'runway-anime-ship',
    title: 'Harbor Song',
    style: 'Anime · Character',
    provider: 'Runway Gen-3 Alpha',
    prompt:
      'A Japanese animated film of a young woman standing on a ship and looking back at camera.',
    videoUrl:
      'https://d3phaj0sisr2ct.cloudfront.net/site/videos/gen-3-alpha/artists/gen-3-alpha-output-011.mp4',
  },
  {
    id: 'runway-creature-city',
    title: 'Night Walker',
    style: 'Sci-fi · Wide shot',
    provider: 'Runway Gen-3 Alpha',
    prompt:
      'View out a window of a giant strange creature walking in a rundown city at night, one street lamp dimly lighting the area.',
    videoUrl:
      'https://d3phaj0sisr2ct.cloudfront.net/site/videos/gen-3-alpha/artists/gen-3-alpha-output-001-v1.mp4',
  },
];

/** Subset for landing hero (2×2 grid). */
export const heroShowcaseMovies = dashboardShowcaseMovies.slice(0, 4);
